const {
  GET_ORDER_BY_ID,
  GET_ORDER_BY_ID_REQUEST,
  GET_ORDER_BY_ID_ERROR,
} = require('../actions/types');

const initialState = {
  loading: true,
  data: null,
  error: null,
};

// eslint-disable-next-line import/no-anonymous-default-export
export default function (state = initialState, action) {
  const { type, payload } = action;
  switch (type) {
    case GET_ORDER_BY_ID_REQUEST:
      return {
        ...state,
        loading: true,
        data: null,
        error: null,
      };
    case GET_ORDER_BY_ID:
      return {
        ...state,
        data: payload,
        loading: false,
      };
    case GET_ORDER_BY_ID_ERROR:
      return {
        ...state,
        error: payload,
        loading: false,
      };
    default:
      return state;
  }
}
